import { PlayButton } from "@southfields-digital/mxmz-react-ui";
import { useEffect } from "react";

import type { Clock } from "src/types/matchControl/clock";

import { useTimer } from "../hooks";
import { getFormattedTime } from "../utils";

type ChildClockProps = {
	clock: Clock;
	handleToggleClock: (clock: Clock) => void;
};

const ChildClock = ({ clock, handleToggleClock }: ChildClockProps) => {
	const { time: clockTime, setTimer: setClockTime } = useTimer(
		100,
		clock.clockTime,
		clock.clockCountDirection,
	);

	useEffect(() => {
		const serverTimeOffset = clock.serverTimeUpdate
			? new Date(clock.serverTimeUpdate).getTime() - Date.now()
			: 0;

		const startedAt = clock.clockTimeUpdatedAt
			? new Date(clock.clockTimeUpdatedAt).getTime() - serverTimeOffset
			: null;

		setClockTime(clock.clockTime || 0, startedAt ? new Date(startedAt) : null);
	}, [clock, clock.clockTimeUpdatedAt, clock.clockTime]);

	return (
		<div className="flex flex-row gap-2 items-center">
			{getFormattedTime(clockTime, "seconds", false)} sec
			<PlayButton
				hasIcon
				isRunning={Boolean(clock.clockTimeUpdatedAt)}
				onClick={() => handleToggleClock(clock)}
				iconProps={{
					icon: clock.clockTimeUpdatedAt ? "stop" : "play",
					weight: "bold",
					size: 20,
				}}
				className="!h-9 !w-16 place-content-center"
			/>
		</div>
	);
};

export default ChildClock;
